import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './index.css'
import { initializeI18nSync, LANGUAGE_STORAGE_KEY, supportedLanguages } from './i18n/config'
import App from './App.jsx'

const root = createRoot(document.getElementById('root'));

// Check if we were redirected from 404.html (GitHub Pages)
const redirectPath = sessionStorage.getItem('redirectPath');
if (redirectPath) {
  window.history.replaceState(null, '', redirectPath);
  sessionStorage.removeItem('redirectPath');
}

const actualPath = window.location.pathname;

// Detect language from the path - DISABLED FOR NOW
// const pathMatch = actualPath.match(/^\/([a-z]{2})(\/|$)/);
// const urlLang = pathMatch && supportedLanguages.includes(pathMatch[1]) ? pathMatch[1] : null;
const urlLang = null; // Force English only

// Language detection and redirect DISABLED - force English only
// if (!urlLang) {
//   let preferredLang = 'en';
//
//   try {
//     const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
//     if (stored && supportedLanguages.includes(stored)) {
//       preferredLang = stored;
//     } else {
//       const browserLang = navigator.language || navigator.userLanguage;
//       if (browserLang) {
//         const langCode = browserLang.toLowerCase().split('-')[0];
//         if (supportedLanguages.includes(langCode)) {
//           preferredLang = langCode;
//         }
//       }
//     }
//   } catch {
//     const browserLang = navigator.language || navigator.userLanguage;
//     if (browserLang) {
//       const langCode = browserLang.toLowerCase().split('-')[0];
//       if (supportedLanguages.includes(langCode)) {
//         preferredLang = langCode;
//       }
//     }
//   }
//
//   // Redirect to preferred language if not English
//   if (preferredLang !== 'en') {
//     window.location.replace(`/${preferredLang}`);
//   }
// }

// Initialize i18n synchronously with English only for now
const currentLang = 'en'; // Force English
initializeI18nSync(currentLang);

// Render immediately
const AppWrapper = import.meta.env.DEV ? (
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/:lang?" element={<App />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>
) : (
  <BrowserRouter>
    <Routes>
      <Route path="/:lang?" element={<App />} />
    </Routes>
  </BrowserRouter>
);

root.render(AppWrapper);
